import React from 'react';
import WebDesignedFloatingDock from '../WebDesignedFloatingDock';

const MobileFloatingDock: React.FC = () => {
  return <WebDesignedFloatingDock forcedLayoutMode="mobile" />;
};

export default MobileFloatingDock;

